export const GEO_TYPES = {
  CITY: 'city',
  COUNTRY: 'country',
  REGION: 'region',
} as const;

export type GeoType = (typeof GEO_TYPES)[keyof typeof GEO_TYPES];

export type ContextGeoSubject = {
  soguStamp: {
    subject_geo_id: number;
    subject_geo_name: string;
    subject_geo_type: GeoType;
  };
};
